import { QueryParams } from 'api/types/common.types';

export const queryKeys = {
  skinnyBanner: (params: QueryParams) => ['skinnyBanner', params] as const,
  widget: (id?: string) => ['widget', id] as const,
  skinnyBannerUpdateMutation: ['skinnyBannerUpdateMutation'] as const,
  skinnyBannerCreateMutation: ['skinnyBannerCreateMutation'] as const,
};
